import { z } from 'zod'
import { FORBIDDEN_CHARACTERS } from 'helpers/string.helper'

// https://zod.dev/ERROR_HANDLING
// https://zod.dev/?id=refine

// TODO translations - https://github.com/aiji42/zod-i18n perhaps ??
const customErrorMapExample: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === z.ZodIssueCode.invalid_type) {
    if (issue.expected === 'string') {
      return { message: 'Type mismatch error!' }
    }
  }

  return { message: ctx.defaultError }
}

z.setErrorMap(customErrorMapExample)

// convert NaN created by "valueAsNumber" to null to avoid NaN -> number type mismatch error - basically allow empty value as number
export const emptyNumberValueToNull = <T extends z.ZodTypeAny>(zodType: T) => z.preprocess((x) => (!Number.isNaN(x) ? x : null), zodType)

export const emptyStringValueToNull = <T extends z.ZodTypeAny>(zodType: T) => z.preprocess((x) => x || null, zodType)

export const withoutForbiddenCharacters = (value: string | null, ctx: z.RefinementCtx) => {
  if (value !== null && FORBIDDEN_CHARACTERS.some((char) => value.includes(char))) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Text cannot forbidden unicode characters ',
    })
  }
}
